import { DistanceUnit } from './distance-unit';

export class PathSearchCriteria {
  originLatitude: number;
  originLongitude: number;
  destinationLatitude: number;
  destinationLongitude: number;
  distanceUnit?: DistanceUnit;

  constructor(
    originLatitude: number,
    originLongitude: number,
    destinationLatitude: number,
    destinationLongitude: number,
    distanceUnit: DistanceUnit
  ) {
    this.originLatitude       = originLatitude;
    this.originLongitude      = originLongitude;
    this.destinationLatitude  = destinationLatitude;
    this.destinationLongitude = destinationLongitude;
    this.distanceUnit         = distanceUnit;
  }

  public toHttpParams(): { [param: string]: string | string[] } {
    let params = {
      destinationLatitude: this.destinationLatitude.toString(),
      destinationLongitude: this.destinationLongitude.toString(),
      originLatitude: this.originLatitude.toString(),
      originLongitude: this.originLongitude.toString(),
    };

    if (this.distanceUnit) {
      params['distanceUnit'] = this.distanceUnit;
    }

    return params
  }
}
